import React, { useMemo, useRef } from 'react';
import AnimalList from './AnimalList';
import SpeciesList from './SpeciesList';

export default function SpeciesButton(props: any) {
  const ref = useRef<HTMLDivElement>(null);
  const imagePriorityProps = { fetchpriority: 'low' } as React.ImgHTMLAttributes<HTMLImageElement>;
  const accessibilityLabel = props.group.accessibilityLabel ?? props.group.name;

  const flattenedGroup = useMemo(() => {
    if (!props.group.openAnimalsDirectly) {
      return null;
    }

    return {
      ...props.group,
      individuals: props.group.entries.reduce((allIndividuals: Array<any>, entry: any) => {
        if (!Array.isArray(entry.individuals) || entry.individuals.length === 0) {
          return allIndividuals;
        }

        return allIndividuals.concat(entry.individuals);
      }, []),
    };
  }, [props.group]);

  function handleClick(event: React.MouseEvent<HTMLDivElement>) {
    if (props.isOpen) props.onClose();
    else props.onOpen();
  }
  function close(event: MouseEvent) {
    if (ref.current!.contains(event.target as Node)) return;
    props.onClose();
  }

  return (
    <div ref={ref} className='species-button-container'>
      {props.isOpen 
        ? props.group.openAnimalsDirectly && flattenedGroup
          ? <div className={`popup-container ${props.isMobile ? 'popup-container--mobile' : 'popup-container--desktop'}`}>
              <AnimalList
                inlineDesktop={!props.isMobile}
                group={flattenedGroup}
                name={props.group.name}
                onClickOutside={close}
                onSelected={(selected: any) => {
                  props.onSelected(selected);
                  props.onClose();
                }}
              />
            </div>
          : <SpeciesList isMobile={props.isMobile} onClose={props.onClose} onClickOutside={close} onSelected={(selected: any) => {
              props.onSelected(selected);
              props.onClose();
            }} group={props.group} /> 
        : null
      }
      <div onClick={handleClick}>
        <div className='species-button' >
          <img src={props.img} alt={accessibilityLabel} height="100%" decoding="async" {...imagePriorityProps} />
          <div className="species-button-after" style={{ borderColor: props.group.color }} />
        </div>
      </div>
    </div>
  )
}